import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent {
  id: string = "";
  constructor(private route: ActivatedRoute){
    
  }

  ngOnInit(): void {
    this.route.paramMap
    .subscribe(params => {
      this.id = params.get("id")??"";
    })
  }
}
